import type { MatchupRow } from "./types";

export interface MatchupProgress {
  resolved: number;
  total: number;
}

export function isResolved(matchup: MatchupRow): boolean {
  return Boolean(matchup.result);
}

export function countResolved(matchups: MatchupRow[]): MatchupProgress {
  return {
    resolved: matchups.filter(isResolved).length,
    total: matchups.length,
  };
}
